// 채널톡 상담 열기.
// 채널톡 스크립트는 public/index.html 이 페이지 로드 1초 뒤에 심는다. 그 전에 누르면
// window.ChannelIO 가 아직 없으므로 잠깐 기다렸다가 연다. 끝내 없으면(광고 차단 등) onFail.
const WAIT_MS = 5000;
const POLL_MS = 200;

export const openChannelChat = (onFail?: () => void) => {
  const started = Date.now();
  const tryOpen = () => {
    const ChannelIO = (window as any).ChannelIO;
    if (typeof ChannelIO === "function") {
      // chatId 없이 부르면 새 상담 채팅이 열린다
      ChannelIO("openChat");
      return;
    }
    if (Date.now() - started >= WAIT_MS) {
      onFail?.();
      return;
    }
    setTimeout(tryOpen, POLL_MS);
  };
  tryOpen();
};

export const CHANNEL_FAIL_MESSAGE =
  "채팅 상담을 열 수 없습니다.\n광고 차단 기능을 끄거나 잠시 후 다시 시도해 주세요.\n전화 상담: 070-4799-2557";
